import axios from 'axios';
import React, { useEffect } from 'react';
import ImageUploading from 'react-images-uploading';
import { config } from '../../data/config';
import { getCookies } from "cookies-next";
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

export default function ImageUploaders({ count = 1, id, component, reload = null }: any) {
    const { t } = useTranslation();

    const [images, setImages] = React.useState([]);
    const [listimage, setlistimage] = React.useState([]);
    const [key, setKey] = React.useState(0);
    const [uploading, setUploading] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [deletingId, setDeletingId] = React.useState<string | null>(null);
    const [movingId, setMovingId] = React.useState<string | null>(null);
    const [previewImage, setPreviewImage] = React.useState<string | null>(null);

    const maxNumber = 69;
    let cookie = getCookies();

    const onChange = async (imageList: any, addUpdateIndex: any) => {
        if (addUpdateIndex.length === 0) return;
        
        setUploading(true);
        try {
            await Promise.all(
                addUpdateIndex.map(async (i: any) => {
                    let formData = new FormData();
                    formData.append("file", imageList[i].file);
                    formData.append("component", component);
                    formData.append("parent", id);

                    await axios({
                        method: "post",
                        url: config.url + "/v1/dashboard/filemanager",
                        data: formData,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                            "Content-Type": "multipart/form-data"
                        },
                    });
                })
            );

            Swal.fire({
                title: t('Uploaded successfully'),
                icon: 'success',
                timer: 1200,
                showConfirmButton: false,
            });

            setImages([]);
            await loaditem();
        } catch (error) {
            console.error('Upload failed:', error);
            Swal.fire({
                title: t('Upload failed'),
                text: t('Please try again'),
                icon: 'error',
            });
        } finally {
            setUploading(false);
        }

        return true;
    };
    const orderup = async (myid: any) => {
        setMovingId(myid);
        try {
            await axios({
                method: "put",
                url: config.url + "/v1/dashboard/filemanager/orderup/" + myid,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                    "Content-Type": "multipart/form-data"
                },
            });
            await loaditem();
            if (reload) reload();
        } catch (error) {
            console.error('Move failed:', error);
            Swal.fire({
                title: t('Error'),
                text: t('Failed to move image'),
                icon: 'error',
            });
        } finally {
            setMovingId(null);
        }
    };

    const orderdoown = async (myid: any) => {
        setMovingId(myid);
        try {
            await axios({
                method: "put",
                url: config.url + "/v1/dashboard/filemanager/orderdown/" + myid,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                    "Content-Type": "multipart/form-data"
                },
            });
            await loaditem();
            if (reload) reload();
        } catch (error) {
            console.error('Move failed:', error);
            Swal.fire({
                title: t('Error'),
                text: t('Failed to move image'),
                icon: 'error',
            });
        } finally {
            setMovingId(null);
        }
    };
    const loaditem = async () => {
        setLoading(true);
        try {
            const response = await axios({
                method: "get",
                url: config.url + "/v1/dashboard/filemanager?id=" + id + "&component=" + component,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                    "Content-Type": "multipart/form-data"
                },
            });
            setlistimage(response.data.data || []);
            if (reload) reload();
            setKey(key + 1);
        } catch (error) {
            console.error('Load failed:', error);
            Swal.fire({
                title: t('Error loading images'),
                icon: 'error',
            });
        } finally {
            setLoading(false);
        }
    };

    const deletedItem = async (myid: any) => {
        const result = await Swal.fire({
            title: t('Delete image?'),
            text: t('This action cannot be undone'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('Yes, delete'),
            cancelButtonText: t('Cancel'),
        });

        if (!result.isConfirmed) return;

        setDeletingId(myid);
        try {
            await axios({
                method: "delete",
                url: config.url + "/v1/dashboard/filemanager/" + myid,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                    "Content-Type": "multipart/form-data"
                },
            });
            Swal.fire({
                title: t('Deleted'),
                icon: 'success',
                timer: 1200,
                showConfirmButton: false,
            });
            await loaditem();
            if (reload) reload();
        } catch (error) {
            console.error('Delete failed:', error);
            Swal.fire({
                title: t('Error'),
                text: t('Failed to delete image'),
                icon: 'error',
            });
        } finally {
            setDeletingId(null);
        }
    };
    useEffect(() => {
        loaditem();
    }, []);

    // Handle Escape key to close preview
    useEffect(() => {
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && previewImage) {
                setPreviewImage(null);
            }
        };
        if (previewImage) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [previewImage]);

    return (
        <>
            <div className="w-full" dir="rtl">
                {/* Upload Area */}
                <div className="mb-6">
                    <ImageUploading
                        multiple
                        value={images}
                        onChange={onChange}
                        maxNumber={count}
                        dataURLKey="data_url"
                    >
                        {({
                            imageList,
                            onImageUpload,
                            onImageRemoveAll,
                            onImageUpdate,
                            onImageRemove,
                            isDragging,
                            dragProps,
                        }) => (
                            <div className="upload__image-wrapper">
                                <button
                                    onClick={onImageUpload}
                                    {...dragProps}
                                    disabled={uploading}
                                    className={`
                                        w-full py-8 px-6 rounded-xl border-2 border-dashed transition-all duration-300
                                        ${isDragging 
                                            ? 'border-blue-500 bg-blue-50 shadow-lg scale-[1.02]' 
                                            : 'border-gray-300 bg-gray-50 hover:border-blue-400 hover:bg-blue-50/30 hover:shadow-md'
                                        }
                                        ${uploading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
                                        flex flex-col items-center justify-center gap-3
                                    `}
                                >
                                    {uploading ? (
                                        <>
                                            <div className="bg-blue-100 rounded-full p-3">
                                                <svg className="animate-spin h-6 w-6 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                            </div>
                                            <span className="text-sm text-gray-700 font-medium">{t('Uploading...')}</span>
                                        </>
                                    ) : (
                                        <>
                                            <div className={`bg-blue-100 rounded-full p-4 transition-colors duration-300 ${isDragging ? 'bg-blue-200' : ''}`}>
                                                <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                </svg>
                                            </div>
                                            <div className="text-center">
                                                <span className="text-sm text-gray-700 font-medium block">
                                                    {isDragging ? t('Drop images here') : t('Click or Drop here')}
                                                </span>
                                                <span className="text-xs text-gray-500 mt-1 block">
                                                    {t('Upload up to')} {count} {t('images')}
                                                </span>
                                            </div>
                                        </>
                                    )}
                                </button>
                            </div>
                        )}
                    </ImageUploading>
                </div>

                {/* Images Grid */}
                {loading ? (
                    <div className="flex items-center justify-center py-12">
                        <svg className="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                ) : listimage.length > 0 ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        {listimage.map((item: any, index: number) => (
                            <div
                                key={item.id}
                                className="relative bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-300 group"
                            >
                                {/* Image */}
                                <div className="relative aspect-square bg-gray-50 cursor-pointer" onClick={() => setPreviewImage(`${config.fronturl}/${item.url}`)}>
                                    <img
                                        src={config.fronturl + '/' + item.url}
                                        alt={item.title || `${t('Image')} ${index + 1}`}
                                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                                        onError={(e) => {
                                            e.currentTarget.src = '/placeholder-image.jpg';
                                            e.currentTarget.className = 'w-full h-full object-cover opacity-50';
                                        }}
                                    />
                                    {/* Overlay on hover */}
                                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                                    
                                    {/* Image number badge */}
                                    <div className="absolute top-2 right-2 bg-black/70 text-white text-xs px-2.5 py-1 rounded-full font-medium backdrop-blur-sm">
                                        {index + 1} / {listimage.length}
                                    </div>

                                    {/* Preview icon on hover */}
                                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                        <div className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg">
                                            <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className="p-3 border-t border-gray-100 bg-white">
                                    <div className="grid grid-cols-4 gap-2">
                                        {/* Preview */}
                                        <button
                                            onClick={() => setPreviewImage(`${config.fronturl}/${item.url}`)}
                                            className="flex items-center justify-center p-2 bg-purple-50 hover:bg-purple-100 text-purple-600 rounded-lg transition-all duration-200 group/btn"
                                            title={t('Preview')}
                                        >
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                        </button>

                                        {/* Delete */}
                                        <button
                                            onClick={() => deletedItem(item.id)}
                                            disabled={deletingId === item.id}
                                            className="flex items-center justify-center p-2 bg-red-50 hover:bg-red-100 text-red-600 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                            title={t('Delete')}
                                        >
                                            {deletingId === item.id ? (
                                                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                            ) : (
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                            )}
                                        </button>

                                        {/* Move Up */}
                                        <button
                                            onClick={() => orderup(item.id)}
                                            disabled={movingId === item.id || index === 0}
                                            className="flex items-center justify-center p-2 bg-green-50 hover:bg-green-100 text-green-600 rounded-lg transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
                                            title={t('Move up')}
                                        >
                                            {movingId === item.id ? (
                                                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                            ) : (
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                </svg>
                                            )}
                                        </button>

                                        {/* Move Down */}
                                        <button
                                            onClick={() => orderdoown(item.id)}
                                            disabled={movingId === item.id || index === listimage.length - 1}
                                            className="flex items-center justify-center p-2 bg-green-50 hover:bg-green-100 text-green-600 rounded-lg transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
                                            title={t('Move down')}
                                        >
                                            {movingId === item.id ? (
                                                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                            ) : (
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                </svg>
                                            )}
                                        </button>
                                    </div>

                                    {/* Edit Link */}
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={`/dashboard/Gallery/detailimage/${item.id}`}
                                        className="mt-2 flex items-center justify-center gap-2 p-2 bg-blue-50 hover:bg-blue-100 text-blue-600 rounded-lg transition-all duration-200 text-sm font-medium"
                                        title={t('Edit')}
                                    >
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                        </svg>
                                        {t('Edit')}
                                    </a>

                                    {/* Title */}
                                    {item.title && (
                                        <div className="mt-2 p-2 bg-gray-50 rounded-lg text-xs text-gray-700 text-right line-clamp-2">
                                            {item.title}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-12 text-gray-400">
                        <div className="flex flex-col items-center">
                            <svg className="w-12 h-12 mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <p className="text-sm">{t('No images uploaded yet')}</p>
                        </div>
                    </div>
                )}
            </div>

            {/* Preview Modal */}
            {previewImage && (
                <div
                    className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
                    onClick={() => setPreviewImage(null)}
                >
                    <div className="relative max-w-7xl max-h-[90vh] w-full h-full flex items-center justify-center">
                        <button
                            onClick={() => setPreviewImage(null)}
                            className="absolute top-4 right-4 bg-white/90 hover:bg-white rounded-full p-2 shadow-lg transition-all duration-200 z-10"
                        >
                            <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <img
                            src={previewImage}
                            alt={t('Preview')}
                            className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
                            onClick={(e) => e.stopPropagation()}
                            onError={(e) => {
                                e.currentTarget.src = '/placeholder-image.jpg';
                                e.currentTarget.className = 'max-w-full max-h-full object-contain opacity-50 rounded-lg';
                            }}
                        />
                    </div>
                </div>
            )}
        </>
    );
}